import type { Props as IconProps } from 'components/Icon';
import { Icon } from 'components/Icon';
import { Button, ButtonProps } from 'components/Button';

export type Props<T extends React.ElementType> = {
  name: IconProps['name'];
  title: string;
  iconClasses?: string;
} & ButtonProps<T>;

export const IconButton = <T extends React.ElementType>({
  name,
  title,
  iconClasses,
  ...props
}: Props<T>): JSX.Element => {
  return (
     
    <Button iconOnly {...props}>
      <Icon name={name} title={title} className={iconClasses} />
    </Button>
  );
};
